import React, { Component } from 'react';
import { Tabs, Tab, Box, Typography, Badge } from '@mui/material';
import TabPanel from '../../common/TabPanel';
import StudentDetails from '../StudentDetails';
import { getColumns } from './utils';

class ResultsTabs extends Component {
  state = {
    tabSelected: 0,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isLoading !== this.props.isLoading && this.props.isLoading) {
      this.setState({ tabSelected: 0 });
    }
  }

  onChange = (event, value) => {
    this.setState({ tabSelected: value });
  };

  render() {
    const { id } = this.props;
    const isNotFoundUinExists = !this.props.isLoading && this.props.notFoundStudents.length;

    return (
      <>
        <Box sx={{ width: '100%', pb: 1 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              className="myOdu__tabs"
              value={this.state.tabSelected}
              onChange={this.onChange}
              aria-label="Student Search Results Tabs"
            >
              <Tab
                label="Search Results"
                id={`${id}__tab_searchResults`}
                aria-controls={'checklists__tabpanel_all_items'}
              />
              {isNotFoundUinExists ? (
                <Tab
                  label={
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <span>Error</span>

                      <Badge className="badge">{this.props.notFoundStudents.length}</Badge>
                    </Box>
                  }
                  id={`${id}__tab_error`}
                  aria-controls={'checklists__tabpanel_required'}
                />
              ) : null}
            </Tabs>
          </Box>
        </Box>

        <TabPanel
          value={this.state.tabSelected}
          sx={{ pt: 1, px: 0 }}
          index={0}
          id={`${id}__tabpanel_searchResults`}
          labelledby={`${id}__tab_searchResults`}
        >
          <StudentDetails
            id={`${id}_searchResults`}
            isStudentSearch={true}
            students={this.props.students}
            columns={getColumns()}
            isHideCheckbox={true}
            noStudentMessage={
              this.props.errorMessage ? this.props.errorMessage : 'No students found.'
            }
            isLoading={this.props.isLoading}
          />
        </TabPanel>

        {isNotFoundUinExists ? (
          <TabPanel
            value={this.state.tabSelected}
            sx={{ pt: 1, px: 0 }}
            index={1}
            id={`${id}__tabpanel_error`}
            labelledby={`${id}__tab_error`}
          >
            <Typography py={2} variant="small" className="myOdu__error">
              Students not found; invalid UINs or user is not a current student.
            </Typography>

            <StudentDetails
              id={`${id}_notFoundResults`}
              isStudentSearch={true}
              students={this.props.notFoundStudents}
              getRowId={(row) => row.SPRIDEN_ID}
              columns={[
                {
                  field: 'SPRIDEN_ID',
                  headerName: 'Student ID',
                },
              ]}
              isHideCheckbox={true}
              noStudentMessage={
                this.props.errorMessage ? this.props.errorMessage : 'No students found.'
              }
              isLoading={this.props.isLoading}
            />
          </TabPanel>
        ) : null}
      </>
    );
  }
}

export default ResultsTabs;
